//@ts-nocheck
import React, { useState, useRef } from 'react'
import { Transforms, Node, Editor } from 'slate'
import { ReactEditor } from 'slate-react'
import { ModalBody, ModalHeader, ModalFooter, Button, ButtonGroup, Icon } from '../../../../../../index'

import { ImageEditForm } from './ImageEditForm'
//@ts-ignore
import styles from './style.module.css'
import { handleImageError } from './withImage'
import cloneDeep from 'lodash/cloneDeep';
import ImageSizeField from './ImageSizeField'
import classNames from 'classnames'
import { getInitialWidthHeight, isPositiveNumber, calculateImageDimensions } from './utils'

export const ImageEditModal = ({ element, editor, type, ...props }) => {
  const [updatedFormData, setUpdatedFormData] = useState()
  const [hasError, setHasError] = useState(false)
  const [naturalImageWH, setNaturalImageWH] = useState();
  const imagePreviewRef = useRef();
  const imageSizeInputEnabled = props.imageSizeInputEnabled;

  const updateFormData = (formData) => {
    if (imageSizeInputEnabled) {
      imagePreviewRef.current.style.width = formData.width && isPositiveNumber(formData.width) ? `${formData.width}px` : 'auto';
      imagePreviewRef.current.style.height = formData.height && isPositiveNumber(formData.height) ? `${formData.height}px` : 'auto';
    }
    setUpdatedFormData(prev => ({ ...prev, ...formData }))
  }

  const handleFormSubmit = (values) => {
    let fields = { ...values }

    if (fields['inline']) {
      if (fields['position'] === 'center' || !fields['position']) {
        /* istanbul ignore next */
        fields['position'] = 'left'
      }
    }
    const path = ReactEditor.findPath(editor, element)

    const newAttributes = {
      ...element.attrs,
      "redactor-attributes": {
        ...element.attrs?.["redactor-attributes"]
      },
      style: {
        ...element.attrs?.style
      }
    }
    Object.entries(fields).forEach(([f, v]) => {
      const field = f
      const value: any = v
      if (value && value !== '') {
        if (!['width', 'height'].includes(field)) {
          newAttributes["redactor-attributes"][field] = value
        }
        if (field === 'inline') {
          newAttributes['inline'] = value
        }


        if (field === 'url') {
          newAttributes['url'] = value
        }
        if (field === 'caption' || field === 'anchorLink') {
          /* istanbul ignore if */
          if (type === 'asset') {
            if (field === 'caption')
              newAttributes['asset-caption'] = value.trim();
            else newAttributes['link'] = value.trim();
          }
          else
            newAttributes[field] = value.trim()
        }

        if (field === 'position') {
          /* istanbul ignore if */
          if (type === 'asset') {
            newAttributes['position'] = value;
          }
          if (imageSizeInputEnabled) {
            delete newAttributes.style["width"]
            delete newAttributes.style["height"]
            delete newAttributes.style["max-width"]
            delete newAttributes['width']
            delete newAttributes['height']
            delete newAttributes['max-width']
            if (value === 'none') {
              newAttributes["redactor-attributes"]['position'] = 'none'
              delete newAttributes.style["text-align"]
              delete newAttributes.style["float"]

              if (fields.width) newAttributes['width'] = fields.width
              if (fields.height) newAttributes['height'] = fields.height
            } else {
              newAttributes.style["text-align"] = value
              newAttributes["redactor-attributes"]['position'] = value

              if (value !== 'center') {
                if (fields.width) {
                  newAttributes['width'] = fields.width
                  newAttributes['max-width'] = fields.width
                  newAttributes.style["width"] = `${fields.width}px`
                  newAttributes.style["max-width"] = `${fields.width}px`
                }
                if (fields.height) {
                  newAttributes['height'] = fields.height
                  // newAttributes.style["height"] = `${fields.height}px`
                }
                newAttributes.style["float"] = value
              }
              else {
                if (newAttributes['max-width']) {
                  // newAttributes['width'] = newAttributes['max-width']
                  delete newAttributes.style["float"]
                  delete newAttributes.style["width"]
                  delete newAttributes.style["max-width"]
                  delete newAttributes['max-width']
                  delete newAttributes.style["height"]
                }
                if (fields.width) newAttributes['width'] = fields.width
                if (fields.height) newAttributes['height'] = fields.height
              }
            }
          } else {
            if (value === 'none') {
              newAttributes["redactor-attributes"]['position'] = 'none'
              delete newAttributes.style["text-align"]
              delete newAttributes.style["text-align"]
              delete newAttributes.style["float"]
              delete newAttributes.style["width"]
              delete newAttributes.style["max-width"]
              delete newAttributes['max-width']
            } else {
              newAttributes.style["text-align"] = value
              newAttributes["redactor-attributes"]['position'] = value

              if (value !== 'center') {
                if (newAttributes['max-width']) {
                  newAttributes.style["max-width"] = `${newAttributes['max-width']}px`
                  newAttributes['max-width'] = newAttributes['max-width']
                  newAttributes.style["width"] = `${newAttributes.width}px`
                  newAttributes['width'] = newAttributes.width
                }
                else {
                  newAttributes.style["max-width"] = `${newAttributes['width']}px`
                  newAttributes['max-width'] = newAttributes['width']
                }
                newAttributes.style["float"] = value
              }
              else {
                if (newAttributes['max-width']) {
                  newAttributes['width'] = newAttributes['max-width']
                  delete newAttributes.style["float"]
                  delete newAttributes.style["width"]
                  delete newAttributes.style["max-width"]
                  delete newAttributes['max-width']
                }
              }
            }
          }
        }
        if (field === 'target') {
          newAttributes.target = value ? '_blank' : '_self';
        }
      } else {
        if (field === 'position') {
          delete newAttributes.style["text-align"]
        }
        delete newAttributes[field]
        delete newAttributes["redactor-attributes"][field]
      }

      if (field === 'alt') {
        if (type === 'asset')
          /* istanbul ignore next */
          newAttributes['asset-alt'] = value.trim();
        else {
          newAttributes['alt'] = value.trim()
          newAttributes["redactor-attributes"]['alt'] = value.trim();
        }
      }
    })

    let node = Node.get(editor, path)
    let newNode = cloneDeep(node);
    newNode.attrs = newAttributes;
    if (newAttributes.inline && !Editor.isInline(editor, node)) {
      Transforms.removeNodes(editor, { at: path })
      const inlineImage = {
        type: 'p',
        children: [
          newNode,
        ]
      }
      Transforms.insertNodes(editor, inlineImage, { at: path })
    } else if (!newAttributes.inline && Editor.isInline(editor, node)) {
      // remove the image element from p tag in case inline is disabled after enabling it;
      // removing the node from p tag
      Transforms.removeNodes(editor, { at: path });
      // removing path last item
      path.pop();
      Transforms.insertNodes(editor, newNode, { at: path })
    } else {
      Transforms.setNodes(editor, { attrs: newAttributes }, { at: path })
    }
    // Transforms.setNodes(editor, { attrs: newAttributes }, { at: path })
    props.closeModal()
  }

  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    if (!naturalWidth || !naturalHeight) return;
    let width = updatedFormData?.width || element?.attrs?.width || element?.attrs?.["redactor-attributes"]?.width;
    if (width && !isPositiveNumber(width)) width = undefined;
    let height = updatedFormData?.height || element?.attrs?.height || element?.attrs?.["redactor-attributes"]?.height;
    if (height && !isPositiveNumber(height)) height = undefined;
    setNaturalImageWH(getInitialWidthHeight(naturalWidth, naturalHeight, width, height))
  }

  const modalContainerClass = classNames({
    [styles['scrte-form-container']]: !imageSizeInputEnabled,
    [styles['scrte-img-ele-form-container-big']]: imageSizeInputEnabled
  })

  const imagePreviewClass = classNames({
    [styles['scrte-img-ele-image-preview-big']]: imageSizeInputEnabled,
    [styles['modal']]: !imageSizeInputEnabled
  })

  return (
    <div>
      <ModalHeader title="Edit Image" closeModal={props.closeModal} />

      <ModalBody>
        <div className={modalContainerClass}>
          <div className={classNames({ [styles['scrte-img-ele-image-container-big']]: imageSizeInputEnabled })} >
            <img
              ref={imagePreviewRef}
              onLoad={handleImageLoad}
              src={type === 'asset' ? element.attrs?.['asset-link'] : element.attrs.url}
              className={imagePreviewClass}
              onError={handleImageError}
              data-testid={'scrte-image-element'} />
          </div>
          <div className={imageSizeInputEnabled ? [styles['scrte-img-ele-field-container-big']] : undefined}>
            <ImageEditForm
              attributes={{
                ...element?.attrs,
                ...element?.attrs?.["redactor-attributes"]
              }}
              updateFormData={updateFormData}
              hasError={{ value: hasError, callback: setHasError }}
            >
              {imageSizeInputEnabled && <ImageSizeField
                naturalImageWH={naturalImageWH}
                attributes={calculateImageDimensions(updatedFormData, element)}
                hasError={{ value: hasError, callback: setHasError }}
                updateFormData={updateFormData}
              />}
            </ImageEditForm>
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <ButtonGroup>
          <Button key="cancel" buttonType="light" onClick={() => props.closeModal()} data-testid={'scrte-cancel'}>
            Cancel
          </Button>
          <Button
            icon={'SaveWhite'}
            key="add"
            disabled={hasError}
            onClick={() => {
              handleFormSubmit(updatedFormData)
            }}
            data-testid={'scrte-submit'}
          >
            Save
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </div>
  )
}
